import i18next from 'i18next';

import common_en from './en/common.json';
import common_zh from './zh/common.json';

import autoUpload_en from './en/autoUpload.json';
import autoUpload_zh from './zh/autoUpload.json';

import leadForm_en from './en/leadForm.json';
import leadForm_zh from './zh/leadForm.json';

export function i18nextWithDefaultNS(namespace, defaultLanguage) {
//	console.log( "default namespace: "+namespace );		// debug usage
	
	i18next.init({
		lng: defaultLanguage !== undefined ? defaultLanguage : 'en',
		resources: {
			en: {
		    	common: common_en,
		    	autoUpload: autoUpload_en,
				leadForm: leadForm_en,
		    	//... add product name and its translation file here with key value pair format
		    },
		    zh: {
		    	common: common_zh,
		    	autoUpload: autoUpload_zh,
				leadForm: leadForm_zh,
		    	//... add product name and its translation file here with key value pair format
		    }
		},
		ns: ['common', 'autoUpload'],		//... list all products name here
		defaultNS: namespace,
//		debug: true,		// debug usage
		react: { wait: true }
	}, () => {
		// initialized and ready to go!
//		console.log( i18next.t('product_lbl') );
//		console.log( i18next.t('common:key') );
	});

	// load extra namespaces HERE
	i18next.loadNamespaces('common', (err, t) => { /* ... */ });	
	
	return i18next;
}
